// Modül 1 - Kabin Memurluğuna Giriş - Ek İçerikler

const cabinCrewContentsM1Extra = {
  // Ünite 3 - Günlük Hayat
  'CM-M1-U3-L1': {
    title: 'Bir Günün Anatomisi',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurunun tipik bir iş günü nasıl geçer? Sabahın erken saatlerinden gece geç saatlere kadar uzanan bu yolculuğu keşfedin.',
      sections: [
        {
          title: 'Uçuş Öncesi Hazırlık',
          content: 'Briefing toplantısı, güvenlik kontrolleri, kabin hazırlığı ve yolcu karşılama. Her uçuş öncesi yaklaşık 1-2 saat hazırlık süresi vardır.'
        },
        {
          title: 'Uçuş Sırasında',
          content: 'Güvenlik demonstrasyonu, servis, yolcu isteklerini karşılama, kabin kontrolü ve acil durumlara hazırlık.'
        },
        {
          title: 'Uçuş Sonrası',
          content: 'Debriefing, raporlama, sonraki uçuşa hazırlık veya dinlenme. Layover şehirlerinde konaklama.'
        }
      ],
      tips: ['Her gün farklıdır - rutin yoktur', 'Esneklik en önemli beceridir', 'Jet lag yönetimi kritiktir']
    }
  },
  'CM-M1-U3-L2': {
    title: 'Çalışma Saatleri ve Rotasyon',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurlarının çalışma düzeni, vardiya sistemi ve rotasyon planlaması hakkında bilgi edinin.',
      sections: [
        {
          title: 'Uçuş Saatleri Limitleri',
          content: 'Yasal olarak günlük maksimum uçuş saati 12-14 saat arasındadır. Aylık limit genellikle 80-100 saat civarındadır.'
        },
        {
          title: 'Standby ve Reserve',
          content: 'Yeni kabin memurları genellikle standby (bekleme) görevi yapar. Bu, çağrı geldiğinde 2-4 saat içinde hazır olmak demektir.'
        },
        {
          title: 'Kıdemli Avantajları',
          content: 'Kıdem arttıkça, rota seçimi ve izin planlaması üzerinde daha fazla kontrol sahibi olursunuz.'
        }
      ],
      tips: ['İlk yıl en zorudur', 'Tatil günleri çalışmak normaldir', 'Sosyal hayat planlaması gerekir']
    }
  },
  'CM-M1-U3-L3': {
    title: 'Layover Hayatı',
    type: 'lesson',
    content: {
      introduction: 'Farklı şehirlerde geçirilen geceler, layover deneyimi ve bu süreyi verimli kullanma stratejileri.',
      sections: [
        {
          title: 'Kısa Layover (8-12 saat)',
          content: 'Genellikle sadece dinlenme. Otelden çıkmadan uyku ve toparlanma zamanı.'
        },
        {
          title: 'Uzun Layover (24+ saat)',
          content: 'Şehri keşfetme, alışveriş, turistik aktiviteler. Dünyayı görme fırsatı!'
        },
        {
          title: 'Layover Etiketi',
          content: 'Ekip arkadaşlarıyla iyi ilişkiler, güvenli bölgelerde kalma, sonraki uçuşa hazır olma.'
        }
      ],
      tips: ['Küçük bir valiz her zaman hazır tutun', 'Yerel paraları tanıyın', 'Güvenlik her zaman önce gelir']
    }
  },
  'CM-M1-U3-L4': {
    title: 'Senaryo: Tipik Bir Hafta',
    type: 'scenario',
    scenario: {
      title: 'Yeni Kabin Memurunun Haftası',
      situation: 'Siz yeni işe başlamış bir kabin memurusunuz. Bu hafta programınızda: Pazartesi-Salı İstanbul-Dubai-İstanbul, Çarşamba standby, Perşembe-Cuma İstanbul-Londra (24 saat layover), Cumartesi dönüş, Pazar izin. Arkadaşınız Cumartesi doğum günü partisi yapıyor.',
      question: 'Bu durumu nasıl yönetirsiniz?',
      options: [
        { id: 'a', text: 'Arkadaşıma durumu açıklayıp katılamayacağımı söylerim, telafi için başka bir gün buluşma teklif ederim', correct: true },
        { id: 'b', text: 'Hasta raporu alıp partiye giderim', correct: false },
        { id: 'c', text: 'İşimi bırakıp partiye giderim', correct: false },
        { id: 'd', text: 'Arkadaşıma kızarım çünkü iyi bir gün seçmedi', correct: false }
      ],
      explanation: 'Profesyonellik ve kişisel hayat dengesini kurmak önemlidir. Dürüst iletişim ve alternatif çözümler sunmak en doğru yaklaşımdır.'
    }
  },
  'CM-M1-U3-L5': {
    title: '🎮 Günlük Rutin Eşleştir',
    type: 'matching',
    game: {
      instruction: 'Kabin memurunun günlük aktivitelerini doğru zaman dilimiyle eşleştirin.',
      pairs: [
        { left: 'Briefing toplantısı', right: 'Uçuş öncesi 1.5 saat' },
        { left: 'Güvenlik demonstrasyonu', right: 'Kalkıştan hemen önce' },
        { left: 'Ana yemek servisi', right: 'Uçuş sırasında' },
        { left: 'Debriefing', right: 'İnişten sonra' },
        { left: 'Layover check-in', right: 'Varış havalimanından sonra' }
      ],
      timeLimit: 60
    }
  },

  // Ünite 4 - Kariyer Yolculuğu
  'CM-M1-U4-L1': {
    title: 'Kariyer Basamakları',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurluğunda kariyer gelişimi ve yükselme fırsatları.',
      sections: [
        {
          title: 'Junior Kabin Memuru',
          content: 'İlk 1-2 yıl. Temel görevler, öğrenme süreci, standby ağırlıklı program.'
        },
        {
          title: 'Senior Kabin Memuru',
          content: '3-5 yıl deneyim. Daha iyi rotalar, eğitim verme fırsatı, liderlik rolleri.'
        },
        {
          title: 'Kabin Amiri (Purser)',
          content: 'Ekip liderliği, kabin yönetimi, VIP müşteri ilişkileri, kriz yönetimi.'
        },
        {
          title: 'Eğitmen / Yönetici Pozisyonları',
          content: 'Yer hizmetleri, eğitim departmanı, operasyon yönetimi gibi kariyer alternatifleri.'
        }
      ],
      tips: ['Sürekli öğrenmeye açık olun', 'Ek dil öğrenmek avantaj sağlar', 'İyi performans hızlı yükselme getirir']
    }
  },
  'CM-M1-U4-L2': {
    title: 'Farklı Havayolu Türleri',
    type: 'lesson',
    content: {
      introduction: 'Full-service, low-cost ve charter havayollarında çalışma farklılıkları.',
      sections: [
        {
          title: 'Full-Service (Legacy) Havayolları',
          content: 'THY, Emirates, Lufthansa gibi. Premium servis, uzun mesafe uçuşlar, yüksek standartlar. Genellikle daha iyi maaş ve yan haklar.'
        },
        {
          title: 'Low-Cost Havayolları',
          content: 'Pegasus, Ryanair, EasyJet gibi. Hızlı dönüşler, satış odaklı, dinamik çalışma ortamı. Daha esnek kurallar olabilir.'
        },
        {
          title: 'Charter ve Özel Havayolları',
          content: 'Mevsimlik çalışma, tatil rotaları, farklı müşteri profili. VIP jet kabin memurluğu ayrı bir kategoridir.'
        }
      ],
      tips: ['Her türün avantaj ve dezavantajları var', 'Kariyer hedeflerinize göre seçim yapın', 'Geçiş yapmak mümkündür']
    }
  },
  'CM-M1-U4-L3': {
    title: 'Maaş ve Yan Haklar',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurluğunun maddi boyutu: maaş yapısı, primler ve yan haklar.',
      sections: [
        {
          title: 'Temel Maaş Yapısı',
          content: 'Sabit maaş + uçuş saati başına ödeme + layover harcırahı. Türkiye\'de başlangıç maaşı genellikle asgari ücretin 2-3 katıdır.'
        },
        {
          title: 'Primler ve Bonuslar',
          content: 'Satış primi, dil primi (özellikle nadir diller için), performans bonusu, yılbaşı/bayram çalışma ekleri.'
        },
        {
          title: 'Yan Haklar',
          content: 'Ücretsiz veya indirimli uçuş hakkı (staff travel), sağlık sigortası, üniforma, yemek ve konaklama (layover\'da).'
        }
      ],
      tips: ['İlk yıl maaşı düşük olabilir ama hızla artar', 'Uçuş saati ne kadar fazlaysa maaş o kadar yüksek', 'Staff travel ile dünyayı ucuza gezebilirsiniz']
    }
  },
  'CM-M1-U4-L4': {
    title: '⚡ Kariyer Yarışı',
    type: 'timerace',
    game: {
      instruction: '45 saniyede kabin memurluğu kariyer bilgilerini test edin!',
      questions: [
        { question: 'Kabin amirinin İngilizce karşılığı?', answer: 'Purser', options: ['Purser', 'Captain', 'Steward', 'Manager'] },
        { question: 'Low-cost havayoluna örnek?', answer: 'Pegasus', options: ['THY', 'Pegasus', 'Emirates', 'Lufthansa'] },
        { question: 'Staff travel nedir?', answer: 'İndirimli uçuş hakkı', options: ['Maaş', 'İndirimli uçuş hakkı', 'İzin', 'Sigorta'] },
        { question: 'Junior kabin memuru kaç yıl?', answer: '1-2 yıl', options: ['1-2 yıl', '5+ yıl', '10+ yıl', '6 ay'] },
        { question: 'Layover harcırahı ne için?', answer: 'Yurtdışı masrafları', options: ['Yurtdışı masrafları', 'Uçak yakıtı', 'Sigorta', 'Vergi'] }
      ],
      timeLimit: 45
    }
  },

  // Ünite 5 - Mesleğin Zorlukları
  'CM-M1-U5-L1': {
    title: 'Fiziksel Zorluklar',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurluğunun bedeniniz üzerindeki etkileri ve bunlarla başa çıkma yolları.',
      sections: [
        {
          title: 'Jet Lag ve Uyku Düzensizliği',
          content: 'Farklı zaman dilimlerinde uçuş yapmak vücut saatini bozar. Uyku kalitesi düşer, yorgunluk artar.'
        },
        {
          title: 'Uzun Süreli Ayakta Kalma',
          content: 'Uçuş boyunca hareket halinde olmak bacak ve ayak sağlığını etkiler. Kompresyon çorabı ve rahat ayakkabı şart.'
        },
        {
          title: 'Kabin Basıncı Etkileri',
          content: 'Düşük nem, basınç değişimleri cilt ve solunum sistemini etkiler. Bol su içmek önemlidir.'
        }
      ],
      tips: ['Düzenli egzersiz yapın', 'Su tüketimine dikkat edin', 'Cilt bakımı rutini oluşturun']
    }
  },
  'CM-M1-U5-L2': {
    title: 'Duygusal Zorluklar',
    type: 'lesson',
    content: {
      introduction: 'Kabin memurluğunun psikolojik boyutu ve duygusal dayanıklılık.',
      sections: [
        {
          title: 'Aileden Uzak Kalma',
          content: 'Özel günlerde çalışmak, aile etkinliklerini kaçırmak duygusal olarak zorlu olabilir.'
        },
        {
          title: 'Zor Yolcularla Başa Çıkma',
          content: 'Kaba, sarhoş veya talepkar yolcular stres kaynağıdır. Profesyonel duruş korumak şarttır.'
        },
        {
          title: 'Rutin Eksikliği',
          content: 'Her gün farklı olması hem avantaj hem dezavantajdır. Belirsizliğe tolerans gerekir.'
        }
      ],
      tips: ['Destek ağı oluşturun', 'Stres yönetimi tekniklerini öğrenin', 'Hobi edinmeye zaman ayırın']
    }
  },
  'CM-M1-U5-L3': {
    title: 'Senaryo: Zor Karar',
    type: 'scenario',
    scenario: {
      title: 'Aile mi Kariyer mi?',
      situation: 'Annenizin ameliyatı var ve tam o gün uzun mesafe bir uçuşunuz planlandı. Hastalık izni almak için yeterli gününüz yok ve şirket kurallarına göre bu durum \'acil aile durumu\' kapsamında değil.',
      question: 'Bu durumu nasıl yönetirsiniz?',
      options: [
        { id: 'a', text: 'Amirimle açıkça konuşur, program değişikliği veya rota takası için çözüm ararım', correct: true },
        { id: 'b', text: 'Sahte hastalık raporu alırım', correct: false },
        { id: 'c', text: 'Uçuşa gitmem ve sonuçlarını kabullenirim', correct: false },
        { id: 'd', text: 'Sessizce gider ve ailemle iletişimi keserim', correct: false }
      ],
      explanation: 'Dürüst iletişim her zaman en iyi yoldur. İyi bir şirket ve anlayışlı amir genellikle çözüm odaklı yaklaşır. Rota takası (swap) veya standby ile değişim gibi seçenekler mümkündür.'
    }
  },
  'CM-M1-U5-L4': {
    title: '🎮 Doğru mu Yanlış mı?',
    type: 'truefalse',
    game: {
      instruction: 'Kabin memurluğu hakkındaki ifadelerin doğru veya yanlış olduğunu belirleyin.',
      statements: [
        { statement: 'Kabin memurları her zaman lüks otellerde kalır', isTrue: false, explanation: 'Havayoluna ve rotaya göre değişir, bazen budget oteller de olabilir' },
        { statement: 'Jet lag sadece yeni çalışanları etkiler', isTrue: false, explanation: 'Deneyimli ekip üyeleri de jet lag yaşar, sadece daha iyi yönetirler' },
        { statement: 'Kabin memurları indirimli uçuş hakkına sahiptir', isTrue: true, explanation: 'Staff travel ile çok uygun fiyata seyahat edebilirler' },
        { statement: 'Tatil günlerinde çalışmak zorunlu olabilir', isTrue: true, explanation: 'Havacılık 7/24 çalışır, bayram ve tatillerde de uçuş vardır' },
        { statement: 'Tüm havayollarının maaş yapısı aynıdır', isTrue: false, explanation: 'Maaşlar havayoluna, ülkeye ve pozisyona göre büyük farklılık gösterir' }
      ]
    }
  },

  // Ünite 6 - Final Quiz
  'CM-M1-U6-L1': {
    title: 'Genel Tekrar',
    type: 'lesson',
    content: {
      introduction: 'Modül 1\'de öğrendiklerimizin özeti.',
      sections: [
        {
          title: 'Mesleğin Gerçeği',
          content: 'Kabin memurluğu glamour görünümün ötesinde, güvenlik odaklı, zorlu ama ödüllendirici bir meslektir.'
        },
        {
          title: 'Günlük Hayat',
          content: 'Düzensiz saatler, layover\'lar, jet lag - ama aynı zamanda dünyayı görme ve farklı kültürlerle tanışma fırsatı.'
        },
        {
          title: 'Kariyer Fırsatları',
          content: 'Junior\'dan purserlığa, eğitmenlikten yönetime - birçok kariyer yolu mevcut.'
        },
        {
          title: 'Zorluklar',
          content: 'Fiziksel ve duygusal zorluklar var ama doğru kişi için bunlar aşılabilir engellerdir.'
        }
      ],
      tips: ['Bu meslek herkes için değil', 'Kendinizi tanıyın ve bilinçli karar verin', 'Motivasyonunuz ne? Cevabınız açık olsun']
    }
  },
  'CM-M1-U6-L2': {
    title: '🎓 Modül 1 Final Sınavı',
    type: 'exam',
    exam: {
      title: 'Kabin Memurluğuna Giriş - Final Sınavı',
      passingScore: 70,
      questions: [
        {
          question: 'Kabin memurunun birincil görevi nedir?',
          options: ['Yemek servisi', 'Yolcu güvenliği', 'Satış yapmak', 'Temizlik'],
          correct: 1
        },
        {
          question: 'Briefing toplantısı ne zaman yapılır?',
          options: ['İnişten sonra', 'Uçuş öncesi', 'Uçuş sırasında', 'Layover\'da'],
          correct: 1
        },
        {
          question: 'Standby görevi ne anlama gelir?',
          options: ['İzin günü', 'Çağrı için hazır bekleme', 'Eğitim', 'Yöneticilik'],
          correct: 1
        },
        {
          question: 'Purser kimdir?',
          options: ['Pilot', 'Kabin amiri', 'Yolcu', 'Yer personeli'],
          correct: 1
        },
        {
          question: 'Staff travel ne sağlar?',
          options: ['Yüksek maaş', 'İndirimli uçuş imkanı', 'Erken emeklilik', 'Ek izin'],
          correct: 1
        },
        {
          question: 'Jet lag neden oluşur?',
          options: ['Yorgunluktan', 'Zaman dilimi değişikliğinden', 'Kötü yemekten', 'Gürültüden'],
          correct: 1
        },
        {
          question: 'Low-cost havayoluna örnek hangisidir?',
          options: ['Emirates', 'Pegasus', 'Singapore Airlines', 'Qatar Airways'],
          correct: 1
        },
        {
          question: 'Debriefing ne zaman yapılır?',
          options: ['Uçuş öncesi', 'Uçuş sırasında', 'Uçuş sonrası', 'Layover\'da'],
          correct: 2
        }
      ]
    }
  }
};

export default cabinCrewContentsM1Extra;
